import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default {
  mainText:
    "Netcom Computers Pvt Ltd is an Information Technology based company in Education and Training.",
  socialMedia: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/Netcom-Computers-Pvt-Ltd-112386218128697",
      color: "#4267B2",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/netcomcomputers_official/",
      color: `linear-gradient(to right, #833ab4, #fd1d1d, #fcb045)`,
    },
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/company/netcom-computers-pvt-ltd/",
      color: "#0077b5",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/NetcomTvl",
      color: "#00acee",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UCsLbLIoP2MLN-v87Z7hk9ew",
      color: "#FF0000",
    },
    {
      icon: <WhatsAppIcon />,
      link: "https://wa.me/+917538862862",
      color: "#25D366",
    },
  ],
  siteMap: [
    {
      text: "Smart Class Room",
      link: "/smart-class",
    },
    {
      text: "Netcom Digital Content",
      link: "/netcom-digital-contents",
    },
    {
      text: "Language Lab",
      link: "/language-lab",
    },
    {
      text: "Call Soft",
      link: "/call-soft-project",
    },
    {
      text: "Assessment",
      link: "/assessment-project",
    },
    {
      text: "Skill Development & Training",
      link: "/skill-develoment-&-training",
    },
    {
      text: "Kiosk Project",
      link: "/kiosk-project",
    },
    {
      text: "Privacy Policy",
      link: "/privacypolicy",
    },
  ],
  whatWeDo:
    "Netcom Computers has a team of working with many fields of IT industry. We have strong foothold in a variety of fields like computer education, computer aided education, soft skill training, software solutions, web solutions, 3D and 2D animations, cartoon animations, etc.,",
};
